module.exports = __webpack_public_path__ + "assets/img/30_pdd_100x100.07da9798.png";